import { ChallengeIdeas, LastingValue, TrustBuilding } from './styles'

export const aboutInformation = [
  {
    image: <ChallengeIdeas />,
    title: 'Challenge past ideas',
    description:
      "No idea is taken as fact, we're always open to better ways to build our products and teams. The best idea in the room wins, no matter where it's coming from or how long the previous one has been standing.",
  },
  {
    image: <TrustBuilding />,
    title: 'Transparency to build trust',
    description:
      "People invest where they trust, and for that, transparency is key.\n We're open about how our products work and what you get from them. No hidden info or concealed changes.",
  },
  {
    image: <LastingValue />,
    title: 'Create lasting value',
    description:
      "We strive to become the go-to index platform for the new age of finance. We're here for the long run, not the hype.\n No shortcuts are taken, we take the hard approach to building Phuture.",
  },
]
